<template>
    <div>
        <template v-if="messages.length > 0">
            <message-item v-for="message in messages" :message="message" :key="'msg_' + message.id" :swap-to-from="true" :hide-controls="true"></message-item>
        </template>
        <message-employee-field :employee-id="employeeId"></message-employee-field>
    </div>
</template>

<script>
import Events from "../../events";
import MessageItem from "./MessageItem";
import MessageEmployeeField from "./MessageEmployeeField";

export default {
    name: "EmployeeMessages",
    components:{
        MessageItem,
        MessageEmployeeField
    },
    props:{
        employeeId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            messages:[],
        }
    },
    mounted() {
        if(this.employeeId > 0){
            this.loadMessages();
        }
        Events.addEventListener("reload-messages", this.loadMessages);
    },
    methods: {
        loadMessages(){
            axios.get("/api/messages/get/employee/" + this.employeeId).then(
                (pack) => this.loadedMessages(pack.data),
                (pack) => this.loadMessageFailure(pack),
            );
        },
        loadedMessages(response){
            if(response.success){
                this.messages = response.data;
            }
        },
        loadMessageFailure(pack){
            console.warn(pack);
        }
    }
}
</script>
<style scoped></style>
